function initMulticolumnScroll() {
  if (!gsap || !ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  const containers = document.querySelectorAll('[data-multicolumn-animated]');
  if (!containers.length) return;

  containers.forEach((container) => {
    if (container.dataset.multicolumnInitialized) return;
    container.dataset.multicolumnInitialized = true;

    const sections = gsap.utils.toArray(container.querySelectorAll('.panel'));
    if (!sections.length) return;

    ScrollTrigger.matchMedia({
      '(max-width: 749px)': function () {
        gsap.to(sections, {
          xPercent: -100 * (sections.length - 1),
          ease: 'none',
          scrollTrigger: {
            trigger: container,
            pin: false,
            start: '-550px',
            scrub: 1,
            snap: {
              snapTo: 1 / (sections.length - 1),
              duration: 0.4,
              ease: 'power1.inOut',
            },
            endTrigger: '.ending',
            end: () => '+=' + container.offsetWidth,
          },
        });
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', initMulticolumnScroll);
document.addEventListener('shopify:section:load', initMulticolumnScroll);
document.addEventListener('shopify:section:unload', (event) => {
  const containers = event.target.querySelectorAll('[data-multicolumn-animated]');
  containers.forEach((container) => {
    container.dataset.multicolumnInitialized = false;
    ScrollTrigger.getAll().forEach((st) => st.kill());
  });
});
